<template>
  <div>
    <p>
      <strong>1) What will I earn as a referrer?</strong>
      <label>You will earn $2 USD when the person you referred fully pays back their loan</label>
    </p>
    <p>
      <strong>2) What are the conditions to become a referrer? </strong>
      <label>
        Be a Cash Hero user. Fill out the referral form. The Referee should be a Cambodian citizen, age 18 to 50 years
        old, lives in Phnom Penh, Siem Reap, or Sihanoukville and has a stable monthly income.
      </label>
    </p>
    <p>
      <strong>3) How do I get paid?</strong>
      <label>
        Cash Hero will make the payment to your bank account. You will get an email when the referee’s loan is paid off
        and payment will be transferred.
      </label>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ReferralEnglish'
}
</script>

<style scoped>

</style>
